import { ENV, IS_DEV } from '@/constants';

//* next dev의 env 도메인은 dev/stage라 소셜 로그인이 그쪽으로 튄다 — 지금 열린 origin(localhost)으로 되돌린다. 제공자엔 local 프로필로 등록돼 있다.
export const resolveAuthOrigin = (currentOrigin: string) =>
  IS_DEV ? currentOrigin : ENV.NEXT_PUBLIC_DOMAIN;
